import { FC } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Notice } from './components/Notice';
import { PlaceCenter } from './components/PlaceCenter';
import { Shell } from './components/Shell';
import { Spinner } from './components/Spinner';
import { History } from './pages/History';
import { Inspection } from './pages/Inspection';
import { FillInAlert } from './pages/Inspection/FillAlert';
import { Login } from './pages/Login';
import { Main } from './pages/Main';
import { MalfunctionsFeature } from './pages/Malfunctions';
import { ReservationsFeature } from './pages/Reservations';
import { useOnLocationChange } from './services/browserHistory';
import { useDriver } from './services/driver';
import { useBeforeInstall } from './utils/useInstall';
import { useOffline } from './utils/useOffline';
import { CustomiseMenu } from './pages/CustomiseMenu';
import { LogbookFeature } from './pages/Logbook';
import { useProgramaticNavigator } from './components/useProgramaticNavigator';

interface AppProps {}

export const App: FC<AppProps> = () => {
  const { result, running } = useDriver();

  useBeforeInstall();
  useOffline();
  useOnLocationChange();
  useProgramaticNavigator();

  return (
    <>
      {running ? (
        <PlaceCenter>
          <Spinner />
        </PlaceCenter>
      ) : result ? (
        <Shell>
          <Routes>
            <Route index element={<Main />} />
            <Route path="/history" element={<History />} />
            <Route path="/inspection/:id" element={<Inspection />} />
            <Route path="/reservations" element={<ReservationsFeature />} />
            <Route path="/malfunctions">
              <Route index element={<MalfunctionsFeature />} />
              <Route path=":id" element={<MalfunctionsFeature />} />
            </Route>
            <Route path="/logbook/*" element={<LogbookFeature />} />
            <Route path="/customise" element={<CustomiseMenu />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <FillInAlert />
        </Shell>
      ) : (
        <Login />
      )}
      <Notice />
    </>
  );
};
